module.exports = __webpack_public_path__ + "static/flags/SL-e6e449130db2ff651a6583603c1738ee.gif";